import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://lavzuharkbknonnhreek.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imxhdnp1aGFya2Jrbm9ubmhyZWVrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE5ODc0NDAsImV4cCI6MjA4NzU2MzQ0MH0.Qtfx6Nf7OqTNsXLeeslo__cGsInyF6cIL_ked76qedQ'

// Create Supabase client
export const supabaseClient = createClient(supabaseUrl, supabaseAnonKey)

// Helper to check if we have valid Supabase configuration
export const hasValidSupabaseConfig = () => {
  return supabaseUrl !== 'https://demo.supabase.co' && 
         supabaseAnonKey !== 'demo-key' &&
         supabaseUrl && supabaseAnonKey
}

export default supabaseClient